<template>
    <tree v-if="tree" :tree-data.sync="tree" :activeNode="activeNode"></tree>
</template>

<script>
import Tree from './tree'
import * as treeviewApi from 'api/treeviewApi.js'

export default {
  data () {
    return {
      activeNode: '0',
      menuOpen: false,
      tree: [],
      staticTree: {
        id: 1,
        level: 1,
        label: 'Kantoor',
        root: true,
        addData: 10,
        workbox: false,
        children: [
          {
            id: 2,
            level: 2,
            label: 'Standaard projecten',
            template: true,
            editable: true,
            hasFavorite: true,
            favorite: false,
            addDate: 8,
            workbox: false,
            children: [
              {
                id: 3,
                level: 3,
                label: 'AFAS',
                template: true,
                isWritable: true,
                favorite: false,
                addDate: 8,
                workbox: false
              },
              {
                id: 4,
                level: 3,
                label: 'Algemene administratie',
                isWritable: true,
                favorite: false,
                hasFavorite: true,
                addDate: 8,
                workbox: false,
                children: [
                  {
                    id: 5,
                    level: 4,
                    favorite: true,
                    isFavorite: true,
                    label: 'FAVORITE',
                    addDate: 8,
                    workbox: false
                  },
                  {
                    id: 6,
                    level: 4,
                    favorite: false,
                    label: 'bouwplannen',
                    addDate: 3,
                    workbox: false
                  }
                ]
              },
              {
                id: 7,
                level: 3,
                favorite: false,
                editable: true,
                label: 'Allhands Q2 2019',
                addDate: 1,
                workbox: false
              }
            ]
          },
          {
            id: 10,
            level: 2,
            label: 'Lekkere sjablonen',
            project: true,
            favorite: false,
            addDate: 8,
            workbox: false,
            children: [
              {
                id: 11,
                level: 3,
                favorite: false,
                isWritable: true,
                isConfidential: true,
                label: 'Laatste versie',
                addDate: 1,
                workbox: false
              }
            ]
          },
          {
            id: 12,
            level: 2,
            label: 'Nieuwe project',
            favorite: true,
            isFavorite: true,
            project: true,
            new: true,
            addDate: 8,
            workbox: false
          },
          {
            id: 13,
            level: 2,
            label: 'Prullenbak',
            trash: true,
            favorite: false,
            workbox: false
          }
        ]
      }
    }
  },
  components: {
    Tree
  },
  created () {
    this.loadData()
    this.$eventBus.$on('updateNodes', (node) => {
      if (this.activeNode !== node) {
        this.activeNode = node
      }
    })
  },
  methods: {
    loadData () {
      return treeviewApi.laodFoldersTree().then(folders => {
        for (let i = 0; i < folders.length; i++) {
          folders[i].root = true
          folders[i].level = 1
          folders[i].id = folders[i].folderId
          folders[i].label = folders[i].folderName
        }
        this.tree = folders
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/treeView/treeView.vue